export default __webpack_public_path__ + "static/media/producthunt.079064ac.svg";